import { useState, useEffect, useRef, RefObject } from 'react';
import clock2 from 'assets/icons/clock-active.svg';
import {
    editConversationTitle,
} from 'services/coversationService';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import {
    clockIcon,
    closeHistory,
    deleteIcon,
    editIcon,
    hamburgerIcon,
    saveIcon,
} from 'assets/icons';
import { emailTitleUpdate } from 'services/emailService';
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { setHistoryCalled } from 'redux/counterSlice';
import { useDispatch } from 'react-redux';

function ConversationList({
    current,
    setCurrent,
    handleGetConversation,
    handleGetConversation_2,
    data,
    setData,
    hover,
    setHover,
    visibleRight,
    setVisibleRight,
    getConversations,
    handleDeleteIconClicked,
    showEditDelete,
    setShowEditDelete,
    component,
    source_name,
    emailData,
    setEmailData
}: any) {
    const dispatch = useDispatch();
    const [editingIndices, setEditingIndices] = useState<any>({});
    const [isEditing, setIsEditing] = useState(false)
    const params = useParams();
    const [editValue, setEditValue] = useState('');

    const navigate = useNavigate();
    const editDeleteContainerRef: RefObject<HTMLInputElement> = useRef(null);
    const historyContainerRef: RefObject<HTMLInputElement> = useRef(null);

    // Function to update the title
    const updateTitle = (newTitle: string) => {
        if (component !== "chat-bot" || component !== 'document-processing') {
            setEmailData((prevData: any) => ({
                ...prevData,
                title: newTitle
            }));
        }
    };

    useEffect(() => {
        getConversations();
    }, []);

    //toogle edit-delete component
    const toggleEditDelete = (date: any, index: any) => {
        setShowEditDelete((prevVisibility: any) => ({
            ...prevVisibility,
            [`${date}-${index}`]: !prevVisibility[`${date}-${index}`],
        }));
    };

    const handleHamburgerClick = (event: any, date: any, index: any) => {
        event.stopPropagation();
        toggleEditDelete(date, index);
    };

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (
                editDeleteContainerRef.current &&
                !editDeleteContainerRef.current.contains(event.target)

            ) {
                setShowEditDelete({});
                setIsEditing(false)
                setEditingIndices({})
                const clickedInHistoryContainer = event.target.closest('.history-container');

                if (historyContainerRef.current &&
                    !historyContainerRef.current.contains(event.target)) {
                    const conversationId = clickedInHistoryContainer?.dataset?.conversationId;
                    if (conversationId) {
                        if (component === 'document-processing') {
                            handleGetConversation_2(conversationId, localStorage.getItem('username'))
                        } else if (component === 'chat-bot') {
                            handleGetConversation(conversationId, localStorage.getItem('username'))
                        }
                        navigate(
                            `/${component}/${conversationId}`
                        );
                        setCurrent(conversationId);
                    }

                }
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleHover = (index: any, id: any) => {
        setHover(id);
    };

    const handleNotHover = (index: any, id: any) => {
        setHover(null);
    };

    //Update the editing index for a specific date
    const handleEdit = (date: any, index: any) => {
        setIsEditing(true)
        setEditingIndices((prevEditingIndices: any) => ({
            ...prevEditingIndices,
            [date]: index,
        }));
    };

    const handleUpdateTitle = async (newTitle: any, conId: any) => {
        try {
            let body = {
                conversation_id: conId,
                title: newTitle,
            };
            if (component === "chat-bot" || component === "document-processing") {
                const { result, error } = await editConversationTitle(body);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                await getConversations();
                setEditValue('')
            } else {
                const { result, error } = await emailTitleUpdate(conId, newTitle, source_name);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                await getConversations();
                setEditValue('')
            }
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    };

    const customHeader = (
        <div className="chat-history-title">
            Chat History
        </div>
    );

    return (
        <>
            <Drawer
                open={visibleRight}
                onClose={() => setVisibleRight(false)}
                direction='right'
                className='p-sidebar-right-history'
            >
                <div className='p-sidebar'>
                    <div className='p-sidebar-header p-sidebar-custom-header'>
                        <div className="chat-history-title">
                            Chat History
                        </div>
                    </div>
                    <div className='p-sidebar-content'>
                        <section
                            className={`chat-component-right-section`}
                            style={{ overflowY: "auto" }}
                        >

                            {/* chat-history-section  */}
                            <div className='chat-history-data-section-container'>
                                {Object.keys(data ?? {}).map((date) => {
                                    return data[date].length > 0 &&
                                        <div className='chat-history-data-section' key={date}>
                                            <p className='date'>{date}</p>
                                            {data[date].map((conversation: any, index: any) => (
                                                <div
                                                    role="button"
                                                    onClick={(e: any) => {
                                                        if (current === conversation.conversation_id) return; // Prevent click action if already selected
                                                        e.stopPropagation(); // Stop event propagation
                                                        dispatch(setHistoryCalled(true));
                                                        if (component !== 'document-processing' && component !== 'chat-bot') {
                                                            handleGetConversation(conversation.conversation_id)
                                                        }
                                                        navigate(
                                                            `/${component}/${conversation.conversation_id}`
                                                        );
                                                        setCurrent(conversation.conversation_id);
                                                    }}
                                                    className='history-container'
                                                    ref={historyContainerRef}
                                                    data-conversation-id={conversation.conversation_id}
                                                    key={index}
                                                    onMouseEnter={() =>
                                                        handleHover(
                                                            index,
                                                            conversation.conversation_id
                                                        )
                                                    }
                                                    onMouseLeave={() =>
                                                        handleNotHover(
                                                            index,
                                                            conversation.conversation_id
                                                        )
                                                    }
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    {editingIndices[date] === index && isEditing ? (
                                                        <div className='edit-section' ref={editDeleteContainerRef}
                                                        >
                                                            <input
                                                                className='editable-text'
                                                                type='text'
                                                                value={conversation.title}
                                                                onClick={(e) => e.stopPropagation()}
                                                                onChange={(e) => {
                                                                    const updatedConversation = {
                                                                        ...conversation,
                                                                    };
                                                                    updatedConversation.title =
                                                                        e.target.value;
                                                                    const updatedData = { ...data };
                                                                    updatedData[date][index] =
                                                                        updatedConversation;
                                                                    setData(updatedData);
                                                                    setEditValue(e.target.value);
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        setShowEditDelete({});
                                                                        if (editValue !== "" || conversation.title !== "") {
                                                                            editValue !== "" && handleUpdateTitle(editValue, conversation.conversation_id);
                                                                            setEditingIndices((prevEditingIndices: any) => ({
                                                                                ...prevEditingIndices,
                                                                                [date]: null
                                                                            }));
                                                                            updateTitle(editValue)

                                                                        } else {
                                                                            toast.error("Please enter something", {
                                                                                style: {
                                                                                    backgroundColor: '#F1F1F1', // Grey background
                                                                                }
                                                                            });
                                                                        }
                                                                    }
                                                                }
                                                                }
                                                            />
                                                            <button
                                                                className='save-button'
                                                                onClick={(e: any) => {
                                                                    e.stopPropagation();
                                                                    setShowEditDelete({});
                                                                    if (editValue !== "" || conversation.title !== "") {
                                                                        editValue !== "" && handleUpdateTitle(editValue, conversation.conversation_id);
                                                                        setEditingIndices((prevEditingIndices: any) => ({
                                                                            ...prevEditingIndices,
                                                                            [date]: null
                                                                        }));
                                                                        updateTitle(editValue)

                                                                    } else {
                                                                        toast.error("Please enter something", {
                                                                            style: {
                                                                                backgroundColor: '#F1F1F1', // Grey background
                                                                            }
                                                                        });
                                                                    }
                                                                }}
                                                            >
                                                                <img
                                                                    src={saveIcon}
                                                                    alt='save-button'
                                                                ></img>
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            {current ==
                                                                conversation.conversation_id ? (
                                                                <img
                                                                    id='chat-history-icon'
                                                                    src={clock2}
                                                                    alt='chat-history-icon'
                                                                />
                                                            ) : (
                                                                <img
                                                                    id='chat-history-icon'
                                                                    src={clockIcon}
                                                                    alt='chat-history-icon'
                                                                />
                                                            )}
                                                            <p
                                                                className='history'
                                                                style={
                                                                    current ==
                                                                        conversation.conversation_id
                                                                        ? {
                                                                            color: 'black',
                                                                            cursor: 'default',
                                                                        }
                                                                        : hover ==
                                                                            conversation.conversation_id ||
                                                                            current ==
                                                                            conversation.conversation_id
                                                                            ? {
                                                                                color: 'black',
                                                                                cursor: 'pointer',
                                                                            }
                                                                            : { cursor: 'pointer' }
                                                                }
                                                                title={conversation.title}
                                                            >
                                                                {conversation.title}
                                                            </p>
                                                            {hover ==
                                                                conversation.conversation_id && (
                                                                    <img
                                                                        className='clickable-icon hamburger-icon'
                                                                        src={hamburgerIcon}
                                                                        alt='hamburger-icon'
                                                                        onClick={(event) =>
                                                                            handleHamburgerClick(
                                                                                event,
                                                                                date,
                                                                                index
                                                                            )
                                                                        }
                                                                    />
                                                                )}
                                                            {showEditDelete[`${date}-${index}`] && (
                                                                <div
                                                                    className='edit-delete-container'
                                                                    ref={editDeleteContainerRef}
                                                                >
                                                                    <div
                                                                        className='clickable-icon edit-container'
                                                                        onClick={(e) => {
                                                                            e.stopPropagation()
                                                                            handleEdit(date, index)
                                                                        }
                                                                        }
                                                                    >
                                                                        <img
                                                                            className='clickable-icon edit-button'
                                                                            src={editIcon}
                                                                            alt='edit-button'
                                                                        />
                                                                        <p className='edit-delete-text'>
                                                                            Edit Title
                                                                        </p>
                                                                    </div>
                                                                    <div
                                                                        // ref={editDeleteContainerRef}
                                                                        className='clickable-icon delete-container'
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#staticBackdrop"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation()
                                                                            handleDeleteIconClicked(
                                                                                date,
                                                                                index,
                                                                                conversation.conversation_id
                                                                            )
                                                                        }
                                                                        }
                                                                    >
                                                                        <img
                                                                            className='clickable-icon delete-button'
                                                                            src={deleteIcon}
                                                                            alt='delete-button'
                                                                        />
                                                                        <button type="button" className="edit-delete-text" >
                                                                            Delete
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                }
                                )}
                            </div>
                        </section>
                    </div>
                </div>
            </Drawer>
            {visibleRight && <i className='close-history' onClick={() => setVisibleRight(false)}><img src={closeHistory} alt='close History' /></i>}
        </>
    );
}
export default ConversationList;
